import index from './index.common';
export default index;



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./index.js
 **/